import { Dialog } from '@mui/material';
import { BasicButton } from '@tassat/button';
import { convertMsToHumanTime } from '@tassat/utility';
import * as React from 'react';

import MuiStyles from './styles';
import { InactivityModalProps } from './types';

export default function InactivityModal(props: InactivityModalProps) {
    const {
        inactive,
        inactivityWarningDuration,
        resetInactive,
        logout,
        logoutOffsetDuration
    } = props;

    const classes = MuiStyles(props);

    return (
        <Dialog
            disableEscapeKeyDown
            open={inactive}
        >
            <div className={classes.content}>
                <h1>Warning</h1>
                <p>
                    You have been idle for {convertMsToHumanTime(inactivityWarningDuration, 'minutes')}. To protect your information,
                    you will be logged out in {convertMsToHumanTime(logoutOffsetDuration, 'seconds')} if you do not click &quot;Continue Session&quot;.
                </p>
                <div className={classes.buttons}>
                    <BasicButton
                        onClick={resetInactive}
                        text='Continue session'
                        type='main'
                    />
                    <BasicButton
                        onClick={logout}
                        text='Logout'
                        type='main'
                    />
                </div>
            </div>
        </Dialog>
    );
}